import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ReactQueryDevtools} from 'react-query/devtools';
import App from './App.tsx';
import './global.css';
import './styles/twApplyDirectives.css';
import {OverlayContext} from '@components/packages';
import './i18n';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <OverlayContext>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </OverlayContext>
    </QueryClientProvider>
  </React.StrictMode>,
);
